export const openingText = {
  de: {
    title: "Deine Enklave wächst",
    step: "Schritt",
    minimize: "Einklappen",
    resume: "Einführung fortsetzen",
    skip: "Einführung überspringen",
    back: "Zur Basis",
    next: "Weiter",
    save: "Namen übernehmen",
    name: "Name der Enklave",
    startName: "Morgenhain",
    wait: "Bau läuft …",
    hq: "Command Nexus öffnen",
    build: "Werkstatt platzieren",
    pull: "Erste Fabrikation",
    fight: "Ersten Einsatz prüfen",
    daily: "Tagesgeschenk abholen",
    store: "Starterpaket ansehen",
    finish: "Einführung abschließen",
    intro: "Wir sehen uns deine neue Heimat an …",
    failed: "Bitte versuche es erneut. Dein Fortschritt bleibt erhalten.",
    repair:
      "Dein Trupp braucht Verstärkung oder Reparaturen. Öffne die Einheitenansicht und versuche es danach erneut.",
    headings: [
      "Ein Name für den Neuanfang",
      "Willkommen im Tal",
      "Eine Werkstatt für deine Maschinen",
      "Dein erster Verteidiger",
      "Sichere die Umgebung",
      "Ein größeres Hauptquartier",
      "Dein erstes Tagesgeschenk",
      "Dein nächster Schritt",
    ],
    details: [
      "Gib deiner neuen Heimat einen Namen.",
      "Das Command Nexus ist das Herz der Kolonie. Felder und Betriebe versorgen deine Maschinen und die wachsende Siedlung.",
      "Bringe zuerst das Command Nexus auf Stufe 2. Platziere dann die Werkstatt auf einer freien Fläche und bestätige den Bau.",
      "Die erste Standard-Fabrikation garantiert Schildwall Mk2, einen B-Verteidiger. Nutze die kostenlose tägliche Fabrikation.",
      "Öffne Einsatz 1-1. Prüfe die Zombies, besetze deinen Trupp und starte den Angriff.",
      "Erreiche HQ 3. Die Übersicht zeigt dir, welche Gebäude du für den nötigen Durchschnitt noch bauen oder verbessern musst.",
      "Im Tagesbereich wartet dein Login-Geschenk. Dort findest du außerdem Aufgaben, Aktivitätstruhen und den Belohnungskalender.",
      "Sieh dir das Starterpaket an. Du kannst die Einführung ohne Kauf abschließen.",
    ],
  },
  en: {
    title: "Your Enclave is growing",
    step: "Step",
    minimize: "Collapse",
    resume: "Continue introduction",
    skip: "Skip introduction",
    back: "Back to base",
    next: "Continue",
    save: "Save name",
    name: "Enclave name",
    startName: "Morning Grove",
    wait: "Construction in progress…",
    hq: "Open Command Nexus",
    build: "Place Workshop",
    pull: "First fabrication",
    fight: "Inspect first mission",
    daily: "Claim daily gift",
    store: "View Starter Pack",
    finish: "Finish introduction",
    intro: "Take a look around your new home…",
    failed: "Please try again. Your progress has been kept.",
    repair: "Your squad needs reinforcements or repairs. Open Units, prepare them and try again.",
    headings: [
      "A name for a new beginning",
      "Welcome to the valley",
      "A workshop for your machines",
      "Your first defender",
      "Secure the surroundings",
      "A larger headquarters",
      "Your first daily gift",
      "Your next step",
    ],
    details: [
      "Give your new home a name.",
      "The Command Nexus is the heart of your colony. Fields and production buildings supply its machines and growing settlement.",
      "First upgrade the Command Nexus to level 2. Then place the Workshop on a free area and confirm construction.",
      "Your first standard fabrication guarantees Shieldwall Mk2, a B-tier defender. Use the free daily fabrication.",
      "Open mission 1-1. Inspect the zombies, fill your squad and launch the attack.",
      "Reach HQ 3. Its overview lists which buildings need constructing or upgrading to meet the required average.",
      "Your login gift is waiting in Daily. The same screen contains missions, activity chests and the reward calendar.",
      "Take a look at the Starter Pack. You can finish the introduction without buying it.",
    ],
  },
} as const;
